// Camera movements catalog for Higgsfield AI
export const MOVEMENTS = {
  push: [
    { id: 'dolly_in', name: 'Dolly In', desc: 'Push forward, intimacy and focus' },
    { id: 'dolly_out', name: 'Dolly Out', desc: 'Pull back, reveal environment' },
    { id: 'super_dolly_in', name: 'Super Dolly In', desc: 'Aggressive fast push in' },
    { id: 'super_dolly_out', name: 'Super Dolly Out', desc: 'Aggressive fast pull out' },
    { id: 'zoom_in', name: 'Zoom In', desc: 'Optical zoom in, compress depth' },
    { id: 'zoom_out', name: 'Zoom Out', desc: 'Optical zoom out, expand space' },
    { id: 'rapid_zoom_in', name: 'Rapid Zoom In', desc: 'Fast snap zoom, urgency' },
    { id: 'rapid_zoom_out', name: 'Rapid Zoom Out', desc: 'Fast snap out, reveal' },
    { id: 'crash_zoom_in', name: 'Crash Zoom In', desc: 'Dramatic rapid zoom, shock' },
    { id: 'crash_zoom_out', name: 'Crash Zoom Out', desc: 'Dramatic pull, revelation' },
    { id: 'yoyo_zoom', name: 'YoYo Zoom', desc: 'In-out zoom, disorienting' },
  ],
  rotation: [
    { id: 'orbit_360', name: '360 Orbit', desc: 'Full circle around subject' },
    { id: 'arc_right', name: 'Arc Right', desc: 'Partial arc sweep right' },
    { id: 'arc_left', name: 'Arc Left', desc: 'Partial arc sweep left' },
    { id: 'dutch_angle', name: 'Dutch Angle', desc: 'Tilted frame, tension/unease' },
    { id: 'robo_arm', name: 'Robo Arm', desc: 'Mechanical precision arc' },
    { id: 'snorricam', name: 'Snorricam', desc: 'Body-mounted follows subject' },
    { id: '3d_rotation', name: '3D Rotation', desc: 'Full 3D rotation' },
    { id: 'bullet_time', name: 'Bullet Time', desc: 'Frozen subject, orbiting camera' },
  ],
  lateral: [
    { id: 'pan_left', name: 'Pan Left', desc: 'Camera sweeps left' },
    { id: 'pan_right', name: 'Pan Right', desc: 'Camera sweeps right' },
    { id: 'whip_pan', name: 'Whip Pan', desc: 'Ultra fast pan, energy/transition' },
    { id: 'dolly_left', name: 'Dolly Left', desc: 'Lateral tracking left' },
    { id: 'dolly_right', name: 'Dolly Right', desc: 'Lateral tracking right' },
    { id: 'road_rush', name: 'Road Rush', desc: 'Forward rush, speed effect' },
    { id: 'wiggle', name: 'Wiggle', desc: 'Organic side-to-side' },
  ],
  vertical: [
    { id: 'crane_up', name: 'Crane Up', desc: 'Lift up, reveal grandeur' },
    { id: 'crane_down', name: 'Crane Down', desc: 'Descend, reveal detail' },
    { id: 'tilt_up', name: 'Tilt Up', desc: 'Camera tilts upward' },
    { id: 'tilt_down', name: 'Tilt Down', desc: 'Camera tilts downward' },
    { id: 'fpv_drone', name: 'FPV Drone', desc: 'Agile drone-style flight' },
  ],
  special: [
    { id: 'through_obj_in', name: 'Through Object In', desc: 'Camera enters through object' },
    { id: 'through_obj_out', name: 'Through Object Out', desc: 'Camera exits through object' },
    { id: 'focus_change', name: 'Focus Change', desc: 'Rack focus between planes' },
    { id: 'hyperlapse', name: 'Hyperlapse', desc: 'Accelerated time movement' },
    { id: 'timelapse_glam', name: 'Timelapse Glam', desc: 'Glamour time acceleration' },
    { id: 'timelapse_human', name: 'Timelapse Human', desc: 'Human motion timelapse' },
    { id: 'timelapse_land', name: 'Timelapse Land', desc: 'Landscape timelapse' },
  ],
  static: [
    { id: 'static', name: 'Static', desc: 'Locked frame, no movement' },
    { id: 'handheld', name: 'Handheld', desc: 'Natural documentary shake' },
    { id: 'car_grip', name: 'Car Grip', desc: 'Mounted on vehicle' },
  ]
};

export const MOVEMENT_CATEGORIES = [
  { id: 'push', name: 'Push/Pull' },
  { id: 'rotation', name: 'Rotacion' },
  { id: 'lateral', name: 'Lateral' },
  { id: 'vertical', name: 'Vertical' },
  { id: 'special', name: 'Especial' },
  { id: 'static', name: 'Estatico' },
];

// Modes configuration
export const MODES = [
  { id: 'dialogue', name: 'DIALOGO', desc: 'Habla a camara', icon: 'MessageSquare' },
  { id: 'silent', name: 'SILENCIO', desc: 'Expresion/accion', icon: 'Eye' },
  { id: 'detail', name: 'DETALLE', desc: 'Manos/objeto', icon: 'Hand' },
  { id: 'environmental', name: 'AMBIENTE', desc: 'Locacion/aereo', icon: 'Mountain' },
  { id: 'dualframe', name: 'DOS FRAMES', desc: 'Start + End · Higgsfield interpola', icon: 'ArrowLeftRight' },
];

// Narration styles
export const NARRATION_STYLES = [
  { id: 'deportivo', name: 'DEPORTIVO', desc: 'Narrador, energico', icon: 'Trophy', styleDesc: 'sports commentator style, energetic, fast-paced, enthusiastic, like a live match narrator' },
  { id: 'promocional', name: 'PROMOCIONAL', desc: 'Publicidad, persuasivo', icon: 'Megaphone', styleDesc: 'promotional advertising style, persuasive, warm, inviting, direct call to action' },
  { id: 'conversacional', name: 'CONVERSACIONAL', desc: 'Natural, cercano', icon: 'MessageCircle', styleDesc: 'conversational and natural, friendly, casual, like talking to a friend, close and authentic' },
  { id: 'dramatico', name: 'DRAMATICO', desc: 'Intenso, emocional', icon: 'Theater', styleDesc: 'dramatic and intense, serious tone, emotional weight, cinematic narration style' },
  { id: 'alegre', name: 'ALEGRE', desc: 'Festivo, positivo', icon: 'PartyPopper', styleDesc: 'cheerful and upbeat, joyful, light, fun energy, celebratory tone, vibrant and positive' },
  { id: 'urgente', name: 'URGENTE', desc: 'FOMO, limite de tiempo', icon: 'Zap', styleDesc: 'urgent and direct, time-sensitive tone, creates FOMO, fast delivery, no time to waste' },
];

// Accents
export const ACCENTS = [
  { id: 'guatemalan', name: 'GT', label: 'Guatemalteco', flag: 'GT' },
  { id: 'mexican', name: 'MX', label: 'Mexicano', flag: 'MX' },
];

// Intensities
export const INTENSITIES = [
  { id: 'subtle', name: 'SUBTLE', desc: 'Suave' },
  { id: 'dynamic', name: 'DYNAMIC', desc: 'Cinematografico' },
  { id: 'epic', name: 'EPIC', desc: 'Maximo impacto' },
];

// Loader steps per mode
export const LOADER_STEPS = {
  dialogue: ['Analizando composicion...', 'Detectando plano y emocion...', 'Calibrando acento y estilo...', 'Generando prompt...'],
  silent: ['Analizando composicion...', 'Detectando accion...', 'Generando prompt visual...'],
  detail: ['Analizando detalle...', 'Identificando textura y objeto...', 'Generando prompt...'],
  environmental: ['Analizando escena...', 'Detectando ambiente...', 'Generando prompt aereo...'],
  dualframe: ['Analizando frames...', 'Detectando transicion...', 'Calculando movimiento...', 'Generando prompt...'],
};

// Context placeholder per mode
export const CONTEXT_CONFIG = {
  silent: { label: '03 — Contexto de la toma', placeholder: 'Ej: arbitro levanta tarjeta roja con autoridad...' },
  detail: { label: '03 — Que muestra el detalle', placeholder: 'Ej: mano sosteniendo tarjeta roja, textura...' },
  environmental: { label: '03 — Descripcion del ambiente', placeholder: 'Ej: cancha desde dron, luz dorada de tarde...' },
  dualframe: { label: '03 — Contexto de la transicion', placeholder: 'Ej: zoom out rapido revelando al personaje...' },
};

// Character personality archetypes
export const PERSONALITY_ARCHETYPES = [
  { 
    id: 'lider', 
    name: 'LIDER', 
    desc: 'Confiado, directo',
    icon: 'Trophy',
    traits: 'Postura erguida, pecho hacia adelante, gestos amplios y seguros, mirada directa y penetrante, mandíbula firme, movimientos decisivos y controlados, ocupa espacio con confianza'
  },
  { 
    id: 'pensador', 
    name: 'PENSADOR', 
    desc: 'Analítico, reflexivo',
    icon: 'Eye',
    traits: 'Movimientos pausados y deliberados, mirada reflexiva hacia arriba o al horizonte, gestos de mano al mentón, ceño ligeramente fruncido, postura contemplativa, parpadeos lentos'
  },
  { 
    id: 'energetico', 
    name: 'ENERGETICO', 
    desc: 'Extrovertido, expresivo',
    icon: 'Zap',
    traits: 'Movimientos rápidos y amplios, sonrisa amplia y frecuente, cejas muy expresivas, gesticula mucho con las manos, cambia de posición constantemente, ojos brillantes y abiertos'
  },
  { 
    id: 'calmado', 
    name: 'CALMADO', 
    desc: 'Introvertido, sereno',
    icon: 'MessageCircle',
    traits: 'Gestos sutiles y contenidos, movimientos suaves y fluidos, expresión serena, respiración visible y pausada, sonrisa sutil, mirada tranquila, postura relajada pero presente'
  },
  { 
    id: 'cool', 
    name: 'COOL', 
    desc: 'Relajado, casual',
    icon: 'PartyPopper',
    traits: 'Postura casual y desgarbada, movimientos fluidos sin prisa, media sonrisa o smirk, mirada confiada pero relajada, gestos mínimos pero con estilo, actitud despreocupada'
  },
  { 
    id: 'intenso', 
    name: 'INTENSO', 
    desc: 'Determinado, apasionado',
    icon: 'Megaphone',
    traits: 'Mirada fija e intensa, mandíbula apretada, movimientos con propósito y fuerza, gestos enfáticos, ceño concentrado, postura hacia adelante, energía contenida lista para explotar'
  },
  { 
    id: 'amigable', 
    name: 'AMIGABLE', 
    desc: 'Cálido, accesible',
    icon: 'MessageSquare',
    traits: 'Sonrisa genuina que llega a los ojos, postura abierta e invitante, gestos acogedores, inclinación hacia el interlocutor, expresiones faciales suaves, movimientos cálidos'
  },
  { 
    id: 'custom', 
    name: 'PERSONALIZADO', 
    desc: 'Describe la personalidad',
    icon: 'Hand',
    traits: ''
  },
];
